import { Alert, Grid, LinearProgress } from '@mui/material';
import { t } from 'i18next';
import { useState } from 'react';
import { validateInspectiontURL } from '../../api/url';
import { MuiButton, MuiStack } from '../../components';
import HeaderDetails from '../../components/atoms/headerDetails';
import SkeletonLoader from '../../components/atoms/sketeton';
import { StatusEnum } from '../../constants';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { systemColor } from '../../theme/systemColor';
import useAnalyticsEventTracker from '../../utils/useAnalyticsEventTracker';
import CustomerAndInstallBaseSelect from '../commonViews/searchByType/customerAndInstallBaseSelect';
import SelectInstallbaseAndRider from '../commonViews/searchByType/selectInstallbaseAndRider';
import { info } from '../../theme/colors';
export default function DocumentConversionComponent(props) {
    var _documentDetailsGetBy, _documentDetailsGetBy2, _documentDetailsGetBy3, _documentDetailsGetBy4, _documentDetailsGetBy5, _documentDetailsGetBy6, _documentDetailsGetBy7, _documentDetailsGetBy8, _documentDetailsGetBy9, _documentDetailsGetBy10, _documentDetailsGetBy11, _documentDetailsGetBy12;
    var getByDocumentURL = props.getByDocumentURL, handleHeaderClick = props.handleHeaderClick, handleMoreIconClick = props.handleMoreIconClick, SystemName = props.SystemName, parentComponent = props.parentComponent, APISchema = props.APISchema, documentId = props.documentId, modifyDocumentURL = props.modifyDocumentURL, apiRequestPayload = props.apiRequestPayload, isDisabled = props.isDisabled, createAndEditFlow = props.createAndEditFlow, IsFromParentAPt = props.IsFromParentAPt, createDocumentURL = props.createDocumentURL, isShowSkeleton = props.isShowSkeleton, AwaitingMessage = props.AwaitingMessage, loadingShow = props.loadingShow;
    var trackButtonClick = useAnalyticsEventTracker("DocumentConversionComponent");
    var dispatch = useAppDispatch();
    var documentDetailsGetById = useAppSelector(function (state) { return state.crud; }).documentDetailsGetById;
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var handleBackClick = function () {
        trackButtonClick("ButtonClickEvent", "handleBackClick", undefined);
        handleHeaderClick();
    };
    var handleClick = function (event) {
        event.stopPropagation();
        // setMenus(storedMenuFeatures)
        setAnchorEl(event.currentTarget);
    };
    var listVariants = [{
            id: 1,
            Name: 'General',
            DisplayName: 'General'
        }, {
            id: 2,
            Name: 'TaskDetails',
            DisplayName: 'Task Details'
        }];
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(HeaderDetails, {
        headerTitle: t("Service details"),
        status: (_documentDetailsGetBy = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.StatusName) !== null && _documentDetailsGetBy !== void 0 ? _documentDetailsGetBy : "",
        docDate: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy3 = documentDetailsGetById.data) === null || _documentDetailsGetBy3 === void 0 ? void 0 : _documentDetailsGetBy3.AssignedDate,
        docNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.Code,
        sourceDocumentNo: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy5 = documentDetailsGetById.data) !== null && _documentDetailsGetBy5 !== void 0 && _documentDetailsGetBy5.SourceDocumentNo ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy6 = documentDetailsGetById.data) === null || _documentDetailsGetBy6 === void 0 ? void 0 : _documentDetailsGetBy6.SourceDocumentNo : "",
        onHandleClick: handleBackClick,
        onMoreIconClick: function (event) { return handleClick(event); },
        parentComponent: parentComponent,
        statusKey: (_documentDetailsGetBy7 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy8 = documentDetailsGetById.data) === null || _documentDetailsGetBy8 === void 0 ? void 0 : _documentDetailsGetBy8.Key) !== null && _documentDetailsGetBy7 !== void 0 ? _documentDetailsGetBy7 : '',
        IsFromParentAPt: IsFromParentAPt
    }), loadingShow && /*#__PURE__*/ React.createElement(LinearProgress, null), ((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy9 = documentDetailsGetById.data) === null || _documentDetailsGetBy9 === void 0 ? void 0 : _documentDetailsGetBy9.Key) == StatusEnum.Error || AwaitingMessage) && /*#__PURE__*/ React.createElement(MuiStack, {
        padding: "16px 16px 0px 16px"
    }, /*#__PURE__*/ React.createElement(Alert, {
        style: {
            "padding": " 0px 16px",
            marginBottom: "5px",
            width: '100%'
        },
        variant: "outlined",
        severity: "error"
    }, documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy10 = documentDetailsGetById.data) !== null && _documentDetailsGetBy10 !== void 0 && (_documentDetailsGetBy10 = _documentDetailsGetBy10.SourceMessage) !== null && _documentDetailsGetBy10 !== void 0 && _documentDetailsGetBy10.ErrorMessage ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy11 = documentDetailsGetById.data) === null || _documentDetailsGetBy11 === void 0 || (_documentDetailsGetBy11 = _documentDetailsGetBy11.SourceMessage) === null || _documentDetailsGetBy11 === void 0 ? void 0 : _documentDetailsGetBy11.ErrorMessage : AwaitingMessage)), (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy12 = documentDetailsGetById.data) === null || _documentDetailsGetBy12 === void 0 ? void 0 : _documentDetailsGetBy12.Key) == StatusEnum.Error && /*#__PURE__*/ React.createElement(MuiButton, {
        id: "serviceHistory",
        name: "View Appointment",
        sx: {
            color: info,
            paddingRight: 2,
            alignSelf: 'flex-end',
            backgroundColor: 'transparent'
        },
        variant: "text",
        size: "small",
        onClick: function () { return handleBackClick(); }
    }), /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        paddingX: 2,
        lg: 12,
        xl: 12,
        p: 2
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            border: "1px solid ".concat(systemColor.grey),
            marginRight: '-15px',
            marginLeft: '-15px'
        }
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        px: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        direction: "column",
        bgcolor: systemColor.white,
        px: 1.5,
        border: "1px solid ".concat(systemColor.grey),
        borderRadius: 2,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(CustomerAndInstallBaseSelect, {
        VehiclesDetailsList: documentDetailsGetById ? [documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data] : [],
        customerDetails: documentDetailsGetById ? documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data : {},
        isCheckBoxVisible: false,
        isDisabled: isDisabled,
        parentComponent: parentComponent,
        createAndEditFlow: createAndEditFlow
        // onSelectVehicle={(item: IVehicleDetails) => handleSelectedVehicle(item)}
        ,
        IsFromParentAPt: IsFromParentAPt
    }))), !isShowSkeleton && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: 'space-between',
        bgcolor: systemColor.backgroundColor
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12,
        paddingX: 2
    }, /*#__PURE__*/ React.createElement(SelectInstallbaseAndRider, {
        VehiclesDetailsList: documentDetailsGetById ? [documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data] : [],
        customerDetails: documentDetailsGetById ? documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data : {},
        isCheckBoxVisible: false,
        SystemName: SystemName,
        parentComponent: parentComponent,
        apiRequestPayload: apiRequestPayload,
        module: APISchema,
        parentModuleDocumentId: documentId !== null && documentId !== void 0 ? documentId : "",
        createDocumentURL: createDocumentURL,
        modifyDocumentURL: modifyDocumentURL,
        isDisabled: isDisabled ? isDisabled : false,
        createAndEditFlow: createAndEditFlow,
        IsFromParentAPt: IsFromParentAPt,
        validateDocumentURL: validateInspectiontURL
    }))), isShowSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        style: {
            height: '70vh',
            padding: "10px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)));
}
